<div class="row">
    <div *ngIf="!WarrantyProductList;then NoWarrantyProduct else WarrantyProduct"></div>

    <ng-template #NoWarrantyProduct>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate}}</p>
        </div>
    </ng-template>

    <ng-template #WarrantyProduct>
        <div class="col-lg-6 col-sm-4  m-b-15" *ngFor="let Warranty of WarrantyProductList">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow  overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <div class="d-flex divIcons">
                        <i-tabler name="eye" class="icon-20 d-flex clickIcon"
                            (click)="WarrantyDetails(Warranty.id)"></i-tabler>
                    </div>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content text-center" *ngFor="let product of Warranty.costCalcs">
                    <div class="row text-right">
                        <div class="col-md-12">
                            <p>
                                <span class="spanproduct"> {{ 'ProductsGuarantee' | translate}} :</span>
                                <span>{{product.productName|subString:25}}</span>
                            </p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</div>